import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ProductCard from "./ProductCard";
import Skeleton from "./Skeleton";
import "./clientTheme.css";
import "./ProductShelf.css";

export default function ProductShelf({ title, products, loading, viewAllHref }) {
  const { t } = useTranslation("common");
  if (loading) {
    return (
      <section className="product-shelf">
        <div className="product-shelf-header">
          <h2 className="product-shelf-title">{title}</h2>
        </div>
        <div className="product-shelf-row">
          {Array.from({ length: 5 }).map((_, index) => (
            <div className="product-shelf-item" key={index}>
              <div className="product-shelf-skeleton-card">
                <Skeleton className="product-shelf-skeleton-image" />
                <Skeleton className="product-shelf-skeleton-line" />
                <Skeleton className="product-shelf-skeleton-line product-shelf-skeleton-line-short" />
              </div>
            </div>
          ))}
        </div>
      </section>
    );
  }

  if (!products || products.length === 0) return null;

  return (
    <section className="product-shelf">
      <div className="product-shelf-header">
        <h2 className="product-shelf-title">{title}</h2>
        {viewAllHref && (
          <Link to={viewAllHref} className="product-shelf-view-all">
            {t("viewAll")} <span aria-hidden="true">→</span>
          </Link>
        )}
      </div>
      <div className="product-shelf-row">
        {products.map((product) => (
          <div className="product-shelf-item" key={product.productId}>
            <ProductCard product={product} />
          </div>
        ))}
      </div>
    </section>
  );
}
